// import LocalStorage from '@/services/LocalStorage';
import Http from './Http';

const client = new Http('');

client.getPlansList = () => client.get('', '', '/plans');
client.getSubscription = () => client.get('', '', '/subscription');
client.updateSubscription = (data) =>
  client.put('', data, '/subscription/subscribe');
client.cancelSubscription = () => client.delete('', '', '/subscription/cancel');
client.cancelPendingSubscription = () =>
  client.delete('', '', '/subscription/invoices');
client.subscriptionsList = () => client.get('', '', '/subscriptions');
client.subscriptionsCreditCard = () =>
  client.get('', '', '/subscription/credit-card-data');
client.getSubscriptionPlan = (id) => client.get(id, '', '/subscriptions');
client.getSubscriptionPayments = () =>
  client.get('', '', '/subscription/invoices');
client.subscribePlan = (planId, data) =>
  client.post(data, `plans/${planId}/subscriptions`);
client.updateSubscribePlan = (subId, data) =>
  client.put(`${subId}/change-plan`, data, 'subscriptions/');
client.cancelCreditCard = () =>
  client.delete('', '', '/subscription/credit-card-data');
client.reactivatePlan = (data) =>
  client.post(data, '/subscription/invoices/renew');
client.getInvoices = (pathParams) =>
  client.get(
    '',
    '',
    `/subscription/invoices${pathParams ? `?${pathParams}` : ''}`
  );
client.getPendingInvoices = () =>
  client.get('', '', `/subscription/invoices/pending`);
client.signPlan = (data) => client.post(data, '/subscription/invoices');
client.getConsumptions = () => client.get('', '', `/subscription/consumptions`);
client.getDetailedConsumptions = (startDate, endDate) =>
  client.get(
    '',
    '',
    `/subscription/consumptions/detailed?start_date=${startDate}&finish_date=${endDate}`
  );
client.getPeriodConsumptions = (periodType) =>
  client.get(
    '',
    '',
    `/subscription/consumptions/period?period_type=${periodType}`
  );

export default client;
